
import { overrideStore, parametrize } from 'react-overridable';

import DatasetsResultsListItem from '@js/datasets/search/ResultsListItem';
import { RecordsList } from '@js/oarepo_ui/search/RecordsList';
const RecordsListWithProps = parametrize(RecordsList, { searchEndpoint: "/search" });

overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://datasets-v1.1.0.json', DatasetsResultsListItem);
overrideStore.add('InvenioAppRDM.RecordsList.layout', RecordsListWithProps);
